import { render, staticRenderFns } from "./InvestmentApproachView.vue?vue&type=template&id=3b88b604&scoped=true"
import script from "./InvestmentApproachView.vue?vue&type=script&lang=ts"
export * from "./InvestmentApproachView.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentApproachView.vue?vue&type=style&index=0&id=3b88b604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88b604",
  null
  
)

export default component.exports